let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jY5sI")).then(() => parcelRequire('215xL'));